/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Module_Duration_7_DaysInputs */



/**
* | output |
* | --- |
* | "7 days" |
*
* @param {Module_Duration_7_DaysInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const module_duration_7_days = /** @type {((inputs?: Module_Duration_7_DaysInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Module_Duration_7_DaysInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("7 days")
	return /** @type {LocalizedString} */ ("7 jours")
});